/**
 * Created by Mark on 18/04/2017.
 */

import SelectContent from './select-content.js';
import AboutHomework  from './about-assignments.js';
import AssignAssignments from './assign-assignments.js';
import Save from './save-assignment.js';
export default [AboutHomework , SelectContent , AssignAssignments , Save];



// WEBPACK FOOTER //
// ./src/components/wizard/assignment-steps/index.js